var React = require('react');

function ZapBlue (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#2667ff;}.cls-2{fill:none;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("polygon",{"className":"cls-1","points":"25.86 19.96 29.21 1.25 14.6 13.27 0 25.29 24.14 29.56 20.71 48.75 35.35 36.49 50 24.23 25.86 19.96","key":0}),React.createElement("rect",{"className":"cls-2","width":"50","height":"50","key":1})]))]);
}

ZapBlue.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = ZapBlue;

ZapBlue.default = ZapBlue;
